export default "/images/vendor/flag-icon-css/flags/4x3/ph.svg?af9d4fede28354a0b0426859feebd66c";